import React from 'react';
import { PageHero, SectionLabel, PrimaryButton } from '../components/Shared';
import { methodSteps, images } from '../data/mock';

const Method = () => {
  return (
    <>
      <PageHero
        eyebrow="השיטה"
        title="לא אלתור, אלא"
        accent="הנדסת תהליכים."
        subtitle="כך אנחנו מחברים בין העולם הדיגיטלי המורכב לבין הצורך שלכם בתוצאות פשוטות וחותכות."
        image={images.philosophy}
      />

      <section className="py-20 lg:py-28 bg-cream" aria-label="שלבי השיטה">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
          {methodSteps.map((step) => (
            <article
              key={step.n}
              className="reveal grid lg:grid-cols-12 gap-8 lg:gap-16 py-12 lg:py-16 border-t border-navy/15 last:border-b"
            >
              <div className="lg:col-span-3">
                <p className="font-serif text-5xl lg:text-6xl text-bronze" aria-hidden="true">{step.n}</p>
                <p className="eyebrow mt-4 text-navy/50">שלב {step.n}</p>
              </div>
              <div className="lg:col-span-9">
                <h2 className="display-2 text-navy mb-6">{step.title}</h2>
                <p className="lede text-navy/75 text-lg max-w-3xl">{step.body}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* Closing CTA */}
      <section className="dark-section py-24 lg:py-32 relative overflow-hidden" aria-label="קריאה לפעולה">
        <div className="absolute inset-0 grain pointer-events-none" />
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12 relative">
          <div className="grid lg:grid-cols-12 gap-10 items-end">
            <div className="lg:col-span-8">
              <SectionLabel className="text-cream/60">ממשיכים</SectionLabel>
              <h2 className="display-2 text-cream">
                נתחיל משיחת אבחון —<br />
                <span className="text-bronze">ונבנה משם את המהלך הנכון.</span>
              </h2>
            </div>
            <div className="lg:col-span-4 lg:text-left">
              <PrimaryButton to="/contact" variant="bronze">קבעו שיחה</PrimaryButton>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Method;
